const electricianService = {
  title: "Electrician",
  icon: "⚡",
  shortDescription:
    "Switches, sockets, lights, fans, fittings, wiring checks, and minor electrical repair support.",
  longDescription:
    "Book verified electrical help for repair, installation, replacement, testing, and inspection work. Pricing shown here is indicative for common household and light-site electrical tasks.",
  consultationNote:
    "Complex load issues, concealed wiring, or panel faults may require inspection before final estimate.",
  responsePromise:
    "Platform attempts structured assignment with backend-driven fallback if needed.",
  warrantyPolicy:
    "Revisit or support eligibility depends on job type, material use, and completion condition.",
  subServices: [
    {
      id: "electrician-switch-repair",
      title: "Switch / Socket Repair",
      icon: "🔌",
      group: "Switches & Sockets",
      description:
        "Repair faulty switch, loose socket, or minor fitting issue affecting normal usage.",
      basePrice: 149,
      priceType: "fixed",
      duration: "30-45 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "electrician-switch-installation",
      title: "Switch / Socket Installation",
      icon: "🧰",
      group: "Switches & Sockets",
      description:
        "Install new switchboard point, socket unit, or fitting provided by customer.",
      basePrice: 199,
      priceType: "fixed",
      duration: "30-60 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "electrician-light-installation",
      title: "Light Installation",
      icon: "💡",
      group: "Lights",
      description:
        "Install bulb holder, tube light, wall light, or small decorative light fitting.",
      basePrice: 149,
      priceType: "fixed",
      duration: "20-45 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "electrician-fan-installation",
      title: "Fan Installation",
      icon: "🌀",
      group: "Fans",
      description:
        "Install or replace ceiling fan with mounting and basic connection testing.",
      basePrice: 249,
      priceType: "fixed",
      duration: "45-75 mins",
      warranty: "7 days",
      unit: "job",
    },
    {
      id: "electrician-fan-repair",
      title: "Fan Repair / Check",
      icon: "🔧",
      group: "Fans",
      description:
        "Inspect fan noise, weak spin, regulator issue, or mounting-related problems.",
      basePrice: 199,
      priceType: "inspection",
      duration: "30-45 mins",
      warranty: "Inspection only",
      unit: "visit",
    },
    {
      id: "electrician-mcb-check",
      title: "MCB / Fuse Check",
      icon: "🛡️",
      group: "Protection & Safety",
      description:
        "Inspect tripping MCB, fuse issues, overload behavior, or basic distribution problems.",
      basePrice: 249,
      priceType: "inspection",
      duration: "30-45 mins",
      warranty: "Inspection only",
      unit: "visit",
    },
    {
      id: "electrician-wiring-inspection",
      title: "Wiring Inspection",
      icon: "🧵",
      group: "Wiring",
      description:
        "Inspect visible or suspected internal wiring issues affecting safety or performance.",
      basePrice: 299,
      priceType: "inspection",
      duration: "45-60 mins",
      warranty: "Inspection only",
      unit: "visit",
    },
    {
      id: "electrician-doorbell-installation",
      title: "Doorbell Installation",
      icon: "🔔",
      group: "Accessories",
      description:
        "Install or replace doorbell unit with basic connection and working check.",
      basePrice: 149,
      priceType: "fixed",
      duration: "20-40 mins",
      warranty: "7 days",
      unit: "job",
    },
  ],
};

export default electricianService;